import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'
import * as rd from "diacritics"

import {
  Table,
  Jumbotron,
  Button,
  Tabs,
  Tab,
  Row,
  Grid,
  Col,
  Modal,
  Image,
  Glyphicon,
  Panel,
  ButtonGroup,
  FormControl,
  FormGroup,
  ControlLabel,
  Label
} from 'react-bootstrap';

import If from "../../utils/If"

import Loader from 'react-loader-advanced';

import '../../statics/css/table-exercises.css'

import videoPlayerIcon from '../../statics/images/video_player.svg'
import noVideoPlayerIcon from '../../statics/images/no_video.svg'
import yesVideoPlayerIcon from '../../statics/images/yes_video.svg'

//DAO
import { exercisesByCategoryList, exercisesList } from '../../dao-firebase/exercise-firebase'

class TableExercises extends Component {

  constructor(props) {
    super(props);

    this.state = {

      category: this.props.category,
      exercises: [],
      lastCategory: '',
    };

  }

  componentDidMount() {

  }

  componentWillMount() {
    if (this.state.category) {
      exercisesByCategoryList(this.state.category, (response) => {

        this.setState({
          exercises: response,
        }, () => {

          //console.log(this.state.exercises)
          //Mandando pro pai (Tab) os exercícios recebidos
          this.props.exercisesToSearch(this.state.exercises, this.state.category)
        })
      })
    } else {
      exercisesList((response) => {

        this.setState({
          exercises: response,
          lastCategory: response[0].data.category
        }, () => {

          console.log(this.state.exercises)

        })
      })
    }
  }

  editExercise(exercise) {

    this.props.handleEditExercise(exercise);
  }

  removeExercise(exercise) {
    this.props.handleRemoveExercise(exercise);
  }

  verifySearch(obj) {

    let nameObjFormat = rd.remove(obj.name.toLowerCase());
    let searchFormat = rd.remove(this.props.search.toLowerCase());
    return nameObjFormat.includes(searchFormat);
  }

  renderExercises() {

    return _.map(this.state.exercises, (exercise) => {

      return (

        <If test={(this.props.search && this.props.search != '' && this.verifySearch(exercise.data)) || this.props.search == undefined || this.props.search == ''}>

          <tr className="item-exercises-list">
            <td className="exercise-video">
              <div className="background-video-new-exercise">
                <If test={!exercise.data.url_gif || exercise.data.url_gif == ''}>
                  <Image src={noVideoPlayerIcon} responsive className="img-new-video" />
                </If>
                <If test={exercise.data.url_gif && exercise.data.url_gif != ''}>
                  <Image src={yesVideoPlayerIcon} responsive className="img-new-video" />
                  {/* <Image className="img-gif-on" src={exercise.data.url_gif ? exercise.data.url_gif : ""} responsive /> */}
                </If>
              </div>

            </td>

            <td className="exercise-name">
              <p>{exercise.data.name}</p>
            </td>

            <td className="exercise-description">
              <p>{exercise.data.description.toString().length > 200 ?
                (exercise.data.description.toString().substring(0, 200) + "...")
                :
                exercise.data.description.toString()}</p>
            </td>

            <td className="exercise-actions exercise-actions-table-exercises text-center middle-td">

              <Glyphicon className="action-exercise edit-data-exercise" glyph="pencil" onClick={() => this.editExercise(exercise)} />
              <Glyphicon className="action-exercise remove-data-exercise" glyph="remove" onClick={() => this.removeExercise(exercise)} />
            </td>

          </tr>
        </If>

      )
    })
  }

  render() {

    return (
      <div>
        <Table className={this.props.customClass ? this.props.customClass : ""} responsive>
          {/* <thead>
            <tr>
              <th>Vídeo</th>
              <th>Nome</th>
              <th>Descrição</th>
            </tr>
          </thead> */}
          <tbody>
            {this.renderExercises()}
          </tbody>
        </Table>
      </div >
    );
  }
}

export default TableExercises;



// WEBPACK FOOTER //
// src/components/treinos/table-exercises.js